<template>
        <div data-testid="visit-diagnosis">
            <div class="card-body">
                <list-diagnosis :focus-input="focusAddActionInput" v-on:focused="isFocused" :do-update="reloadDiagnosis" v-on:updated="updateDiagnosisDone" v-on:disease="primaryDisease"></list-diagnosis>
            </div>
            <div class="card-body bg-info">
                <add-diagnosis :focus-input="focusAddDiagnosisInput" v-on:update="updateDiagnosis"></add-diagnosis>
            </div>
            <div class="card-body bg-secondary">
                <add-diagnosis-template v-on:update="updateDiagnosis"></add-diagnosis-template>
            </div>

        </div>
</template>

<script>
  // import { mapState, mapActions } from 'vuex'
  import apiMixin from '@/mixins'
  import ListDiagnosis from './ListDiagnosis.vue'
  import AddDiagnosis from './AddDiagnosis.vue'
  import AddDiagnosisTemplate from './AddDiagnosisTemplate.vue'

  export default {
    data () {
      return {
        reloadDiagnosis: false,
        focusAddDiagnosisInput: false,
        focusAddActionInput: false
      }
    },
    mixins: [apiMixin],
    methods: {
      isFocused () {
        this.focusAddActionInput = false
      },
      updateDiagnosis () {
        this.reloadDiagnosis = true
        this.focusAddDiagnosisInput = false
        this.focusAddActionInput = false
      },
      updateDiagnosisDone: function (diagnosisCount) {
        this.focusAddDiagnosisInput = false
        this.focusAddActionInput = false
        this.reloadDiagnosis = false
        this.chooseWhereToFocus(diagnosisCount)
      },
      chooseWhereToFocus (diagnosisCount) {
        if (diagnosisCount > 0) {
          // vyber input na přidání akce poslední diagnózy
          this.focusAddActionInput = true
        } else {
          // vyber input na přidání diagnózy
          this.focusAddDiagnosisInput = true
        }
      },
      primaryDisease (disease) {
        // FUTURE - Take disease from ListDiagnosis and pass to AddMedicament (as default disease)
        // this.$emit('disease', disease)
      }
    },
    beforeMount () {
      //
    },
    watch: {
      //
    },
    components: {
      ListDiagnosis,
      AddDiagnosis,
      AddDiagnosisTemplate
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Visit/components/VisitDiagnosis.vue?66898fd6